<shared-card-visualizer [cardNumber]="cardNumber"></shared-card-visualizer>

<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl"
    (ngSubmit)="handleFormSubmit($event)">

    <shared-forms-input [compact]="compact" [parentForm]="formControl" name="memberCard" [label]="labelMemberCard"
        pattern="[0-9]*" [numbersOnly]="true" inputmode="numeric" type="text" [maxLength]="maxLength"
        (onButtonClick)="handleErrorButtonClick($event)">
    </shared-forms-input>

    <ng-template #left>
        <shared-link [disabled]="(loading$ | async) || formControl.status === 'PENDING'" [emphasis]="emphasis"
            (onClick)="handleSkipStepClick($event)">
            Skip / I don't have a card
        </shared-link>
    </ng-template>

    <ng-template #right>
        <shared-forms-submit [loading]="loading$ | async" marginTop="none" width="normal" [parentForm]="formControl">
            Next
        </shared-forms-submit>
    </ng-template>

    <shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right">
    </shared-forms-offset-wrapper>


</form>